import {API} from "aws-amplify";
import {action, computed, observable, runInAction, toJS} from "mobx";
import {Order} from "../models/order";
import {OrderStore} from "./store-orders";
import * as _ from "lodash";
import {IOrderStore} from "./store-orders-base";


export class PendingApprovalsStore{

  parent: OrderStore;
  @observable Orders: Order[] = [];
  @observable SortBy: string = "score";
  @observable IsSortAscending: boolean = true;
  @observable page: number = 1;
  @observable itemsPerPage: number = 15;
  @observable TotalCount: number = 0;
  @observable searchKeyword: string = "";
  @observable SelectedItemsForAction: Order[] = [];
  @observable Order: Order | undefined = undefined;

  constructor(parent: OrderStore) {
    this.parent = parent;
  }



  @computed get numberOfSelectedItems() {
    return this.SelectedItemsForAction.length;
  }

  @action loadItems = async () => {
    let fromBackend: Order[] = [];
    try {
      let orders = await API.get("backend", "/orders/pending", {});
      fromBackend = orders;
      runInAction(() => {
        this.Orders = [];
        this.TotalCount = orders.length;
        fromBackend.forEach((item: Order) => {
          this.Orders.push(item);
        });
      });
    } catch (error) {
      throw error;
    }
  };

  @action setItem = (item: Order) => {
    this.Order = item;
  };

  @action loadItem = async (id: string) => {
    let fromBackend: Order | undefined = undefined;
    const foundIndex: number = this.Orders.findIndex(
      (item: Order) => item.Reference === id
    );

    if (foundIndex !== -1) {
      fromBackend = this.Orders[foundIndex];
    } else {
      fromBackend = await API.get("backend", `/orders/${id}`, {});
    }

    runInAction(() => {
      if (fromBackend) {
        this.setItem(fromBackend);
        this.setItem(fromBackend);
      }
    });
    return fromBackend;
  };

  @action SetCurrentPage = async (page: number) => {
    this.page = page;
    await this.loadItems();
  };



  @computed get numberOfPages() {
    return Math.ceil(this.TotalCount / this.itemsPerPage);
  }

  @computed get CleanedOrders(){
    return toJS(this.Orders);
  }
  
}
